import { render, staticRenderFns } from "./modal-welcome.vue?vue&type=template&id=ee5ff374&scoped=true"
import script from "./modal-welcome.vue?vue&type=script&lang=js"
export * from "./modal-welcome.vue?vue&type=script&lang=js"
import style0 from "./modal-welcome.vue?vue&type=style&index=0&id=ee5ff374&prod&lang=scss"
import style1 from "./modal-welcome.vue?vue&type=style&index=1&id=ee5ff374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5ff374",
  null
  
)

export default component.exports